"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryDrugsAndGasesGroupItem_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrugDosageType_1 = require("./SurgeryDrugDosageType");
var SurgeryDrug_1 = require("./SurgeryDrug");
var SurgeryDrugsAndGasesGroup_1 = require("./SurgeryDrugsAndGasesGroup");
var SurgeryGas_1 = require("./SurgeryGas");
var SurgicalDefaults_1 = require("./SurgicalDefaults");
var SurgicalDrugsAndGases_1 = require("./SurgicalDrugsAndGases");
var SurgeryDrugsAndGasesGroupItem_Factory = /** @class */ (function () {
    function SurgeryDrugsAndGasesGroupItem_Factory() {
    }
    SurgeryDrugsAndGasesGroupItem_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Dose: model.Dose,
            EntryType: model.EntryType,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateIncoming(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateIncoming(model.SurgeryDrugRecord),
            SurgeryDrugsAndGasesGroupId: model.SurgeryDrugsAndGasesGroupId,
            SurgeryDrugsAndGasesGroupRecord: SurgeryDrugsAndGasesGroup_1.SurgeryDrugsAndGasesGroup_Factory.CreateIncoming(model.SurgeryDrugsAndGasesGroupRecord),
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateIncoming(model.SurgeryGasRecord),
            SurgicalDefaultsId: model.SurgicalDefaultsId,
            SurgicalDefaultsRecord: SurgicalDefaults_1.SurgicalDefaults_Factory.CreateIncoming(model.SurgicalDefaultsRecord),
            SurgicalDrugsAndGasesRecord: SurgicalDrugsAndGases_1.SurgicalDrugsAndGases_Factory.CreateIncoming(model.SurgicalDrugsAndGasesRecord),
        };
        return result;
    };
    SurgeryDrugsAndGasesGroupItem_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Dose: model.Dose,
            EntryType: model.EntryType,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateOutgoing(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateOutgoing(model.SurgeryDrugRecord),
            SurgeryDrugsAndGasesGroupId: model.SurgeryDrugsAndGasesGroupId,
            SurgeryDrugsAndGasesGroupRecord: SurgeryDrugsAndGasesGroup_1.SurgeryDrugsAndGasesGroup_Factory.CreateOutgoing(model.SurgeryDrugsAndGasesGroupRecord),
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateOutgoing(model.SurgeryGasRecord),
            SurgicalDefaultsId: model.SurgicalDefaultsId,
            SurgicalDefaultsRecord: SurgicalDefaults_1.SurgicalDefaults_Factory.CreateOutgoing(model.SurgicalDefaultsRecord),
            SurgicalDrugsAndGasesRecord: SurgicalDrugsAndGases_1.SurgicalDrugsAndGases_Factory.CreateOutgoing(model.SurgicalDrugsAndGasesRecord),
        };
        return result;
    };
    return SurgeryDrugsAndGasesGroupItem_Factory;
}());
exports.SurgeryDrugsAndGasesGroupItem_Factory = SurgeryDrugsAndGasesGroupItem_Factory;
